import { Close } from '@mui/icons-material'
import { assets } from 'Assets'
import { Button, EmptyState, Form, Input, Table, Text } from 'Components'
import { apiRequest } from 'Services'
import dayjs from 'dayjs'
// import { useBranches } from 'hooks'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { selectOpts } from 'utils'
import { formatDate } from 'utils/formatPrice'

const GL_AccountReport = () => {
  const columns = [
    { name: 'Date', key: 'display_name', render: (data) => formatDate(Date.now()) },
    { name: 'Branch', key: 'branch', },
    { name: 'House Type', key: 'house_type', },
    { name: 'Inventory Source', key: 'house_name', },
  ]
  const [params, setParams] = useState({})
  const [query, setQuery] = useState('')
  const handleChange = (name, value) => setParams(prev => ({ ...prev, [name]: value }))
  useEffect(() => {
    handleChange('date', dayjs(Date.now()).format('YYYY-MM-DD'))
  }, [])
  const generate = async () => {
    const str = (new URLSearchParams(params).toString())
    setQuery(`?${str}`)
    const { data: res } = await apiRequest({ url: `/operations/exports/accounts/csv?${str}`, hasAuth: true, method: 'get' })
    const link = document.createElement('a')
    const url = window.URL.createObjectURL(new Blob([res]))
    link.href = url
    const fileName = `GL Account Balance Report ${dayjs(new Date()).format("DD MMM YY")}.csv`;
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
  const clear = () => {
    setQuery('')
  }
  const { data: report } = useQuery(`/admin/accounting/accounts${query}`)
  const { data: account_code } = useQuery(`/admin/accounting/accounts`)
  const { data: sbu } = useQuery('/admin/accounting/sbu-codes')
  const { data: type } = useQuery('/admin/accounting/account-types')




  // const { branches } = useBranches()


  return (
    <div className=' flex flex-col gap-4'>

      <div className='px-[40px]'>
        <Close onClick={clear} />
        <Form className='border flex justify-around items-center p-4 my-3 rounded-[12px]' direction={'row'}>
          <Input placeholder={dayjs().format('MMM DD, YYYY')} label='Date' name='start_date' type='date' disabled />
          {/* <Input placeholder="Select branch" label='Select branch' name="inventory_source_branch"
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            type='select' option={selectOpts(branches)} /> */}
          <Input placeholder="Select SBU" label='Select SBU' name="sbu_code_id"
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            type='select' option={selectOpts(sbu?.data?.filter(code => code?.status))} />
          <Input placeholder="Account Type" label='Select account type' name="account_type_id"
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            type='select' option={selectOpts(type?.data)} />
          <Input placeholder="Account code" label='Select account code' name="code"
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            type='select' option={selectOpts(account_code?.data, 'name', 'code')} />
          {/* <Input placeholder="Select SBU" label='Select SBU' name="sbu_code_id"
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                type='select' option={selectOpts(sbu?.data)} /> */}
          {/* <Input placeholder="Date" label="File Type" type="select" option={[{ name: 'CSV', value: 'csv' }, { name: 'PDF', value: 'pdf' }]} name/> */}
          {/* <Input placeholder="Select House Type" label="House Type" type="select" onChange={(e) => handleChange(e.target.name, e.target.value)}
            option={[{ label: 'MOH', value: 'moh' }, { label: 'BOH', value: 'boh' }]} name={'with_inventory_source_type'} />
          <Input placeholder="Select Inventory Source" label="Inventory Source" type='select' name={'inventory_source'}
            option={selectOpts(sources?.data)} onChange={(e) => handleChange(e.target.name, e.target.value)} /> */}
          <Button className={'h-[100%] !mt-3'} onClick={generate}>Generate Report</Button>
        </Form>
        <div className=''>
          <Text weight='700' size='26px'>GL Account Balance Report</Text>
        </div>
      </div>
      <Table
        column={columns}
        data={report?.data?.items}
        emptyState={<EmptyState icon={assets.icons.staffMagt} text={'There are no report  yet'} />}
        // url='/operations/reports/inventory-items'
        action={false}
      />
    </div>
  )
}

export default GL_AccountReport